const dtPurchaseChanges = require('./purchaseDeleted-dt-handler')
const otherfieldPurchase = require('./purchaseDeleted-fullcont-otherfield-handler')
const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const dbRequest = require('../../../../../js-network/db-request')
const websocket = require('../../../../../js-network/web-socket')
const purchaseDeletedDt = require('./purchaseDeleted-dt')
const snack = require('./purchaseDeleted-snack')

let restoring = false


export function dtgenerator(result, htmlFc) {
  const dtBody = htmlFc.fullcontHTML.querySelector('#purchaseDeleted-changes')
  if (!dtBody) return

  dtBody.innerHTML = ''

  const data = result.entitychanges?.[0]?.data
  if (!Array.isArray(data) || data.length === 0 || data[0]?.user_name == null) return

  const organizedRows = dtPurchaseChanges.organizeRowEntityChange(data)
  dtBody.insertAdjacentHTML('beforeend', organizedRows)
}

// Mark rows that already have sales. This is visual information in read-only mode.
export function itemWithSale(result) {
  const itemsTable = (result.multiTables || []).find(table => table.tableName === 'purchase_vs_item')
  if (!itemsTable || !Array.isArray(itemsTable.data)) return

  itemsTable.data.forEach(itemData => {
    document.querySelectorAll('#purchaseDeleted_form_purchase_vs_item .line').forEach(line => {
      const item = line.querySelector('.item_id')
      const otherFieldRaw = item?.querySelector('.otherField')?.getAttribute('otherField')
      if (!otherFieldRaw) return

      try {
        const otherField = JSON.parse(otherFieldRaw)
        if (otherField.id === parseInt(itemData.id) && otherField.sold_qty > 0) {
          item.classList.add('textfield-autocomplete-disabled')
          line.classList.add('mt-purchase-restriction')
        }
      } catch (error) {}
    })
  })
}

// Keep the lost/returned section visible without dispatching editable change events.
export function showLost() {
  const fullcont = document.querySelector('#purchaseDeleted-fullcont')
  const lost = fullcont?.querySelector('#purchaseDeleted_lost')
  const lostMultitable = fullcont?.querySelector('#purchaseDeleted_mt_lost')

  if (lost) lost.classList.remove('dn')
  if (lostMultitable) lostMultitable.classList.remove('dn')
}

// Toggle the read-only return columns generated in purchase_vs_item.
export function showReturnMtItem(show) {
  document.querySelectorAll('#purchaseDeleted-fullcont .showReturnMtItem')
    .forEach(element => element.classList.toggle('dn', !show))
  document.querySelectorAll('#purchaseDeleted-fullcont .showtotal')
    .forEach(element => element.classList.toggle('dn', show))
}

// Populate returned quantities and totals after selectOne builds the multitables.
export function fillInputReturnMtItem(keypress = false) {
  let generalTotalPriceReturn = 0

  document.querySelectorAll('#purchaseDeleted_form_purchase_vs_item .line').forEach(line => {
    const item = line.querySelector('.item_id')
    const selected = safeJson(item?.getAttribute('selected'), [])
    if (selected.length === 0) return

    const unitPrice = numberValue(line.querySelector('.unit_price input')?.value)
    const qty = numberValue(line.querySelector('.qty input')?.value)
    const returnInput = line.querySelector('.rQty input')
    let returnedQty = 0

    if (keypress) {
      returnedQty = numberValue(returnInput?.value)
    } else {
      returnedQty = numberValue(otherfieldPurchase.get_otherField(item)?.returned_qty)
      if (returnInput) returnInput.value = returnedQty
    }

    const returnedTotal = (unitPrice * qty) - (unitPrice * returnedQty)
    const totalInput = line.querySelector('.total_price_return input')
    if (totalInput) totalInput.value = returnedTotal.toFixed(2)
    generalTotalPriceReturn += returnedTotal
  })

  const generalInput = document.querySelector('#purchaseDeleted_general_total_price_return input')
  if (generalInput) generalInput.value = generalTotalPriceReturn.toFixed(2)
}

function numberValue(value) {
  const parsed = parseFloat(value)
  return Number.isFinite(parsed) ? parsed : 0
}

function safeJson(value, fallback) {
  try { return JSON.parse(value) } catch (error) { return fallback }
}

export async function restorePurchase(htmlFc) {
  if (restoring) return

  const purchaseId = htmlFc.fullcontHTML.getAttribute('data-dbid')
  if (!purchaseId) {
    snack.start({ act: 'show', id: 'emailResult', text: 'Purchase ID not found' })
    return
  }

  const restoreButton = htmlFc.fullcontHTML.querySelector('.fab-restore > .green')
  const formData = new FormData()
  formData.append('purchase_id', purchaseId)

  restoring = true
  if (restoreButton) restoreButton.style.pointerEvents = 'none'

  try {
    const response = await fetch(
      './server/php/queries/entityFunction/restorePurchase.php',
      {
        method: 'POST',
        body: formData,
        credentials: 'same-origin'
      }
    )

    if (!response.ok) throw new Error(`HTTP ${response.status}`)

    const result = await response.json()
    const wasRestored =
      result.authentication?.val === 'ok' &&
      result.authorization?.val === 'ok' &&
      result.error?.val === 'ok'

    if (!wasRestored) {
      const message =
        result.authentication?.val !== 'ok' ? 'Authentication required' :
        result.authorization?.val !== 'ok' ? 'You are not authorized to restore purchases' :
        'The purchase could not be restored'

      snack.start({ act: 'show', id: 'emailResult', text: message })
      return
    }

    const restoredPurchase = result.data?.[0]
    if (restoredPurchase) {
      restoredPurchase.dest = 'purchase'

      const sendDetail = { to: 'allStaff', from: 'staffDesktop', id: '' }
      websocket.entityUpdate('entityUpdate', 'addRow', restoredPurchase, sendDetail)

    }

    fullcontEntity.hide({ id: 'purchaseDeleted-fullcont' }, htmlFc)
    purchaseDeletedDt.start({
      dest: 'purchaseDeleted',
      elem: 'dt',
      act: 'select',
      entity: 'purchaseDeleted'
    })
    snack.start({ act: 'show', id: 'emailResult', text: 'Purchase restored successfully' })
  } catch (error) {
    snack.start({ act: 'show', id: 'emailResult', text: 'Connection error while restoring purchase' })
  } finally {
    restoring = false
    if (restoreButton) restoreButton.style.pointerEvents = ''
  }
}
